/* eslint-disable no-console */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { isAuthorMode } from '@site/js/utils/author-mode';

import { getFrontendValidationErrors, printFormValidationErrors } from '../form/form-validation';
(function () {
  'use strict';

  const LOADER_ID = 'powerportal-loader';
  const EMAIL_VALIDATION_SELECTOR = 'emailvalidation';
  const ARIA_INVALID_ATTR = 'aria-invalid';

  const STATUS_ALREADY_HAS_ACCESS = 'already-has-access';
  const SIGNUP_STATUS_PARAM = 'signupStatus';
  const SUCCESS_MESSAGE_ID = 'signup-form-success-message';
  const SUCCESS_MESSAGE_FULL_ACCESS_ID = 'signup-form-success-message-full-access';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function showSuccessMessageIfPresent() {
    if (document.documentElement.dataset.ppSuccessMessageHandled) {
      return;
    }
    document.documentElement.dataset.ppSuccessMessageHandled = 'true';
    if (isAuthorMode()) {
      return;
    }
    document.getElementById(SUCCESS_MESSAGE_ID)?.style.setProperty('display', 'none');
    document.getElementById(SUCCESS_MESSAGE_FULL_ACCESS_ID)?.style.setProperty('display', 'none');
    document.getElementById(`${SUCCESS_MESSAGE_ID}-title`)?.style.setProperty('display', 'none');
    document.getElementById(`${SUCCESS_MESSAGE_FULL_ACCESS_ID}-title`)?.style.setProperty('display', 'none');

    const params = new URLSearchParams(window.location.search);
    const status = params.get(SIGNUP_STATUS_PARAM);
    if (!status) {
      return;
    }
    showSuccessMessage(status === STATUS_ALREADY_HAS_ACCESS ? SUCCESS_MESSAGE_FULL_ACCESS_ID : SUCCESS_MESSAGE_ID);
    params.delete(SIGNUP_STATUS_PARAM);
    const cleanedQuery = params.toString();
    const cleanedUrl = window.location.pathname + (cleanedQuery ? `?${cleanedQuery}` : '');
    window.history.replaceState({}, document.title, cleanedUrl);
  }

  function buildSelectorUrl(selector) {
    const path = window.location.pathname
      .replace(/\.html$/, '')
      .replace(/\/+$/, '');
    return `${path}.${selector}.json`;
  }

  function hideLoader(formEl) {
    document.querySelectorAll(`#${LOADER_ID}`).forEach(node => node.remove());
    if (formEl) {
      formEl.removeAttribute('aria-busy');
    }
  }

  function showValidationErrorsIfAny(formEl, infoBoxEl) {
    const validationErrors = getFrontendValidationErrors(formEl);
    if (validationErrors.size === 0) {
      return false;
    }
    printFormValidationErrors(validationErrors);
    if (infoBoxEl) {
      infoBoxEl.style.display = 'block';
    }
    return true;
  }

  function showSuccessMessage(elementId) {
    const otherElementId = elementId === SUCCESS_MESSAGE_FULL_ACCESS_ID
      ? SUCCESS_MESSAGE_ID
      : SUCCESS_MESSAGE_FULL_ACCESS_ID;
    document.getElementById(otherElementId)?.style.setProperty('display', 'none');
    document.getElementById(`${otherElementId}-title`)?.style.setProperty('display', 'none');

    const successMessageEl = document.getElementById(elementId);
    if (!successMessageEl) {
      return;
    }
    successMessageEl.style.display = 'block';
    successMessageEl.setAttribute('aria-live', 'polite');
    if (!successMessageEl.hasAttribute('tabindex')) {
      successMessageEl.setAttribute('tabindex', '-1');
    }
    document.getElementById(`${elementId}-title`)?.style.setProperty('display', 'block');
    successMessageEl.focus();
  }

  // Migrated from the legacy apiURL.js jQuery block - kept as a small helper so the
  // custom-error / email-error styling (formvalidation.css) keeps working unchanged.
  function getOrCreateErrorContainer(field) {
    let container = field.nextElementSibling;
    if (!container || !container.classList.contains('custom-error')) {
      container = document.createElement('div');
      container.className = 'custom-error';
      field.insertAdjacentElement('afterend', container);
    }
    return container;
  }

  function init() {
    showSuccessMessageIfPresent();

    // Hide username and hamburger menu in header on all signup pages
    const isSignupPage = document.querySelector('form[data-pp-sign-up-form-id]');
    if (isSignupPage) {
      const usernameElements = document.querySelectorAll('.cmp-header__top-item-username');
      usernameElements.forEach(element => {
        element.classList.add('hide-username');
        element.closest('.cmp-header__top-item')?.classList.add('hide-username');
      });

      // Hide anonymous profile by targeting enable-logout="false"
      const anonymousLogout = document.querySelector('.cmp-header__logout[enable-logout="false"]');
      if (anonymousLogout) {
        anonymousLogout.style.display = 'none';
      }

      // Hide hamburger menu in mobile view
      const hamburgerMenu = document.querySelector('.cmp-header__toggle-button');
      if (hamburgerMenu) {
        hamburgerMenu.classList.add('hide-on-signup');
      }
    }

    // PowerPortal signup form - email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let isEmailValid = false;

    // PowerPortal signup form - email container
    const emailFieldPowerPortal = document.querySelector('input[type="email"]#email-container-powerportal');
    if (!emailFieldPowerPortal) {
      return;
    }
    emailFieldPowerPortal.value = '';

    emailFieldPowerPortal.setAttribute('required', 'required');
    const emailFieldNode = emailFieldPowerPortal.parentNode;
    if (!emailFieldNode.hasAttribute('data-cmp-required-message')) {
      emailFieldNode.setAttribute('data-cmp-required-message', 'This is a mandatory field.');
    }

    const formElement = emailFieldPowerPortal.closest('form');
    const submitButton = document.getElementById('signup-form-email-check-continue');
    const infoBox = formElement ? formElement.querySelector('div[data-component="Infobox"]') : null;

    emailFieldPowerPortal.addEventListener('input', function () {
      const emailValue = emailFieldPowerPortal.value.trim();
      const errorContainer = getOrCreateErrorContainer(emailFieldPowerPortal);
      const parentWrapper = emailFieldPowerPortal.closest('.cmp-form-text');
      const isInternalDomain = emailValue.toLowerCase().endsWith('@hitachienergy.com');

      // Validate email with regex and check domain
      isEmailValid = emailRegex.test(emailValue) && !isInternalDomain;

      if (isInternalDomain) {
        errorContainer.textContent = 'Email cannot be from the hitachienergy.com domain. Please try another.';
        emailFieldPowerPortal.setAttribute(ARIA_INVALID_ATTR, 'true');
        parentWrapper?.classList.add('hide-tick');
        emailFieldPowerPortal.classList.add('email-error');
      } else {
        errorContainer.textContent = '';
        emailFieldPowerPortal.setAttribute(ARIA_INVALID_ATTR, 'false');
        parentWrapper?.classList.remove('hide-tick');
        emailFieldPowerPortal.classList.remove('email-error');
      }

      if (submitButton) {
        submitButton.style.pointerEvents = 'auto';
        submitButton.style.opacity = '1';
      }
    });

    // PowerPortal signup form - continue button
    if (submitButton) {
      submitButton.addEventListener('click', function (event) {
        event.preventDefault();

        if (document.getElementById(LOADER_ID)) {
          return;
        }

        if (showValidationErrorsIfAny(formElement, infoBox)) {
          return;
        }

        if (!isEmailValid) {
          showValidationErrorsIfAny(formElement, infoBox);
          return;
        }

        const captchaToken = typeof grecaptcha !== 'undefined' ? window.grecaptcha.getResponse() : '';
        if (!captchaToken) {
          const recaptchaInput = document.getElementsByName('recaptcha')[0];
          const captchaContainer = document.querySelector('.cmp-form-captcha');
          if (captchaContainer) {
            captchaContainer.classList.add('is-empty');
          }
          if (recaptchaInput) {
            recaptchaInput.required = true;
            recaptchaInput.setAttribute(ARIA_INVALID_ATTR, 'true');
            recaptchaInput.setCustomValidity('Captcha required');
          }
          showValidationErrorsIfAny(formElement, infoBox);
          return;
        }
        if (infoBox) {
          infoBox.style.display = 'none';
        }

        const emailValue = emailFieldPowerPortal.value.trim();
        const errorPageUrl = formElement.getAttribute('data-pp-sign-up-form-error-page-url');
        const successPageUrl = formElement.getAttribute('data-pp-sign-up-form-success-page-url');

        // Disable button to prevent multiple clicks
        submitButton.disabled = true;
        submitButton.textContent = 'Please wait...';

        // Create and show full-page loader
        formElement.setAttribute('aria-busy', 'true');
        const loader = document.createElement('div');
        loader.id = LOADER_ID;
        loader.className = LOADER_ID;
        loader.setAttribute('role', 'status');
        loader.setAttribute('aria-live', 'polite');
        loader.innerHTML = `
          <div class="powerportal-loader__modal">
            <div class="powerportal-loader__spinner"></div>
            <p class="powerportal-loader__text">Processing your request...</p>
          </div>
        `;
        document.body.appendChild(loader);

        fetch(buildSelectorUrl(EMAIL_VALIDATION_SELECTOR), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            email: emailValue,
            'g-recaptcha-response': captchaToken
          })
        })
          .then(async (response) => {
            const contentType = response.headers.get('content-type') || '';

            let data;

            if (contentType.includes('application/json')) {
              data = await response.json();
            } else {
              data = await response.text();
            }

            return {
              ok: response.ok,
              status: response.status,
              data
            };
          })
          .then(({ ok, status, data }) => {
            hideLoader(formElement);

            if (!ok || status !== 200) {
              submitButton.disabled = false;
              submitButton.textContent = 'Continue';
              // Redirect to the authored error page rather than alerting - matches the other
              // signup steps' approach to hard failures.
              if (errorPageUrl) {
                window.location.href = errorPageUrl;
              }
              return;
            }


            const isHtmlSuccess = typeof data === 'string' && data.includes('Content modified');
            const isJsonSuccess = typeof data === 'object';
            if (!isHtmlSuccess && !isJsonSuccess) {
              return;
            }

            const alreadyHasAccess = isJsonSuccess && data.status === STATUS_ALREADY_HAS_ACCESS;
            if (successPageUrl) {
              const separator = successPageUrl.includes('?') ? '&' : '?';
              const statusParam = alreadyHasAccess ? STATUS_ALREADY_HAS_ACCESS : 'submitted';
              window.location.href = `${successPageUrl}${separator}${SIGNUP_STATUS_PARAM}=${statusParam}`;
              return;
            }
            formElement.style.display = 'none';
            showSuccessMessage(alreadyHasAccess ? SUCCESS_MESSAGE_FULL_ACCESS_ID : SUCCESS_MESSAGE_ID);
          })
          .catch((err) => {

            hideLoader(formElement);
            submitButton.disabled = false;
            submitButton.textContent = 'Continue';
            if (errorPageUrl) {
              window.location.href = errorPageUrl;
            }
          })
          .finally(() => {
            if (typeof grecaptcha !== 'undefined') {
              window.grecaptcha.reset();
            }
          });
      });
    }
  }
})();
